/** @enum */
export const UpdateModes = Object.freeze({
  OPTIMISTIC: 'OPTIMISTIC',
  SYNCHRONOUS: 'SYNCHRONOUS'
})